import React from "react";
import AddItemModal from "./AddItemModal";
import { addDivisionDataAsync } from "../../../lib/common-service";
import { getUserCredential } from "../../../lib/cookies";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";

const AddDivision = ({ isVisible, onClose, onSave }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const cookiesData = getUserCredential();
  const fields = [
    {
      name: "division_name",
      label: "Division Name",
      type: "text",
      required: true,
      autoFocus: true,
      placeholder: "Enter Division Name",
      errorMessage: "Division name is required",
    },
    {
      name: "division_desc",
      label: "Description",
      type: "textarea",
      required: false,
      placeholder: "Enter Division Desc.",
      rows: 3,
    },
  ];

  const initialData = {
    division_name: "",
    division_desc: "",
  };

  const apiConfig = {
    fieldType: "division",
    endpoint: "/api/divisions", // Future API endpoint
    method: "POST",
  };

  const handleSave = async (data) => {
    // Format data for API call
    const bodyData = {
      in_user_id: cookiesData.out_user_id,
      in_tenant_id: cookiesData.out_tenant_id,
      in_division_name: data.division_name,
      in_division_desc: data.division_desc || "",
    };

    try {
      // Make API call to add division
      const result = await addDivisionDataAsync(bodyData, history, dispatch);

      if (result) {
        // Create division object for parent component
        const newDivision = {
          text: data.division_name,
          id: data.division_name.toLowerCase().replace(/\s+/g, "_"),
          desc: data.division_desc || "",
        };

        // Call parent onSave function
        await onSave(newDivision);
        return true; // Success
      } else {
        return false; // API call failed
      }
    } catch (error) {
      console.error("Error adding division:", error);
      return false; // Error occurred
    }
  };

  return (
    <AddItemModal
      isVisible={isVisible}
      onClose={onClose}
      onSave={handleSave}
      title="Add Division"
      fields={fields}
      initialData={initialData}
      apiConfig={apiConfig}
      modalClass="division-modal"
      width={500}
    />
  );
};

export default React.memo(AddDivision);
